import React from 'react';

import PackageHeroSummary from '@/components/PackageHeroSummary';
import { PackagePagePriceWithPointsPlusPaySlider } from '@/v2/components/pages/PackageView/components/PackagePagePrice';
import { SanityApi } from '@/v2/services/sanity/types';
import PriceContainer from '../PriceContainer';

export type LeadInOfferPriceProps = {
  leadInOffer: SanityApi.ParsedResponse.LeadInOffer;
  route: string | undefined;
};

const LeadInOfferPrice = ({ leadInOffer, route }: LeadInOfferPriceProps) => {
  const { packageOffers, travellers, displayTravellerTypes } = leadInOffer;

  if (!route || !packageOffers?.[route]) {
    return null;
  }

  return (
    <PriceContainer>
      <PackageHeroSummary nights={leadInOffer.minNumberOfNights} showNights />
      <PackagePagePriceWithPointsPlusPaySlider
        offerId={leadInOffer.id}
        charges={packageOffers[route]}
        travellers={travellers}
        displayTravellerTypes={displayTravellerTypes}
      />
    </PriceContainer>
  );
};

export default LeadInOfferPrice;
